// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3PqQQSWgVeA-dhgmYHlvMV"};